import { Component, Input, OnInit } from "@angular/core";

export enum WsChipType {
  PRIMARY = "primary",
  SECONDARY = "secondary",
  SUCCESS = "success",
  SUCCESS_DARK = "success_dark",
  DRAFT = "draft",
  WARNING = "warning",
  ERROR = "error",
  INFO = "info",
  DANGER= "danger",
  INFO_SUCCESS = "info_success",
  PROCESSING = "processing",
  // Tipologie notifiche (colori specifici per sezione Tipologia)
  TIPOLOGIA_INFO = "tipologia_info",
  TIPOLOGIA_EVENTO = "tipologia_evento",
  TIPOLOGIA_WARNING = "tipologia_warning",
  TIPOLOGIA_SUCCESS = "tipologia_success",
  TIPOLOGIA_ERROR = "tipologia_error"
}

@Component({
  selector: "ws-chip",
  templateUrl: "./ws-chip.component.html",
  styleUrls: ["./ws-chip.component.scss"],
})
export class WsChipComponent implements OnInit {
  @Input() label: string = "";
  @Input() color?: string = "";
  @Input() backgroundColor?: string = "";
  @Input() type?: WsChipType; // Optional type

  constructor() {}

  ngOnInit() {}

  getChipStyles(): { [key: string]: string } {
    if (this.type) {
      return this.getPredefinedStyles(this.type);
    }
    return {
      color: this.color || "#0A0F27",
      backgroundColor: this.backgroundColor || "#e0e0e0",
    };
  }

  private getPredefinedStyles(type: WsChipType): { [key: string]: string } {
    const styles: {
      [key in WsChipType]: { color: string; backgroundColor: string };
    } = {
      [WsChipType.PRIMARY]: { color: "#fff", backgroundColor: "var(--primary-color, $primaryColor)" },
      [WsChipType.SECONDARY]: { color: "#fff", backgroundColor: "#009ADE" },
      [WsChipType.SUCCESS]: { color: "#0A0F27", backgroundColor: "#AFE8C2" },
      [WsChipType.DRAFT]: { color: "#0A0F27", backgroundColor: "#EAEDED" },
      [WsChipType.SUCCESS_DARK]: { color: "#fff", backgroundColor: "#208F45" },
      [WsChipType.WARNING]: { color: "#0A0F27", backgroundColor: "#FFCC99" },
      [WsChipType.ERROR]: { color: "#0A0F27", backgroundColor: "#FFA3AF" },
      [WsChipType.DANGER]: { color: "#0A0F27", backgroundColor: "#FFA3AF" },
      [WsChipType.INFO]: { color: "#0A0F27", backgroundColor: "#B0B0B0" },
      [WsChipType.INFO_SUCCESS]: { color: "#0A0F27", backgroundColor: "#99B3FF" },
      [WsChipType.PROCESSING]: { color: "#0A0F27", backgroundColor: "#FFCC99" },
      // Tipologie notifiche (colori specifici sezione Tipologia)
      [WsChipType.TIPOLOGIA_INFO]: { color: "#fff", backgroundColor: "#009ade" },
      [WsChipType.TIPOLOGIA_EVENTO]: { color: "#fff", backgroundColor: "#7c5ce0" },
      [WsChipType.TIPOLOGIA_WARNING]: { color: "#424242", backgroundColor: "#ffc800" },
      [WsChipType.TIPOLOGIA_SUCCESS]: { color: "#fff", backgroundColor: "#2f9e66" },
      [WsChipType.TIPOLOGIA_ERROR]: { color: "#fff", backgroundColor: "#cf3f52" }
    };
    return styles[type];
  }
}